// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
// import get from 'lodash/get';

export default function(state = {}, action) {
  // const { store } = action;
  const typeMap = {
    MAGAZINE_ISSUE_POSTS_LOADING() {
      return {
        isLoading: true,
        magazineIssuePosts: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_LOADED() {
      return {
        isLoading: false,
        data: action.magazineIssuePosts
      };
    },
    MAGAZINE_ISSUE_POSTS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineIssuePosts.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
